import { Helmet } from "react-helmet";
import styles from "./style.module.scss";
import ContainerHeaderLayout from "views/components/ContainerHeaderLayout/ContainerHeaderLayout";
import TaskManagerTable from "./TaskManagerTable/TaskManagerTable";
import VLColorfulLoader from "views/uikit/VLColorfulLoader";
import { useUserConfig } from "hooks/useUserConfig";

export default function TaskManagerPage() {
  const userConfig = useUserConfig();
  const isConfigLoading = userConfig.isLoading;
  const loading = userConfig.config.length === 0 || isConfigLoading;

  return (
    <>
      <Helmet>
        <title>Task Manager</title>
      </Helmet>
      <ContainerHeaderLayout
        upperRow={<div className={styles.pageHeader}>Task Manager</div>}
      />
      {loading ? (
        <VLColorfulLoader />
      ) : (
        <div className={styles.content}>
          <TaskManagerTable />
        </div>
      )}
    </>
  );
}
